const BIGDAR = "https://backend-bigdar-new.pmc.tn/";
const SNCT = "https://backend-legacy.pmc.tn/";
const GFRIGO = 'http://41.228.75.175/'

const CURRENT_USER = SNCT;
const currentUserName = "SNCT";
export const environment = {
  production: true,
  base_url: CURRENT_USER,
  useDataBaseToSaveImage: 0,
  current_user: currentUserName,
  // base_url: "http://backend-snct.pmc.tn/",
  // base_url: "https://backend-legacy.pmc.tn/",
  //base_url : "https://necom.pmc.tn/"
  // url ceg https://necom.pmc.tn/
  // url legacy https://backend-legacy.pmc.tn/
};
